"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetTeams = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_query_1 = require("react-query");
const ObjectivesClient_1 = require("client/ObjectivesClient");
const teamsKeys_1 = __importDefault(require("consts/queryKeys/teamsKeys"));
const useGetTeams = (page, params, options) => {
    const fetchTeams = async (olderThan) => {
        const queryParams = {
            ...params,
            ...(olderThan && { olderThan })
        };
        return (0, ObjectivesClient_1.getAllTeam)(queryParams);
    };
    return (0, react_query_1.useInfiniteQuery)(teamsKeys_1.default.teams(page, params), ({ pageParam }) => fetchTeams(pageParam), {
        getNextPageParam: lastPage => {
            return lastPage?.pagination?.next?.olderThan;
        },
        ...options
    });
};
exports.useGetTeams = useGetTeams;
